export enum ESize {
  XS = 'extra small',
  S = 'small',
  M = 'medium',
  L = 'large',
}
